/**
 * MonacoWebpackPlugin
 *
 * This plugin is used to enable support for recent monaco-editor versions (0.55+) without needing outdated plugins.
 */
export class MonacoWebpackPlugin {
    static setupEnvironment() {
        window.MonacoEnvironment = {
            getWorker: function (_moduleId, label) {
                if (label === 'json') {
                    return new Worker(new URL('monaco-editor/esm/vs/language/json/json.worker', import.meta.url));
                }
                if (label === 'css' || label === 'scss' || label === 'less') {
                    return new Worker(new URL('monaco-editor/esm/vs/language/css/css.worker', import.meta.url));
                }
                if (label === 'html' || label === 'handlebars' || label === 'razor') {
                    return new Worker(new URL('monaco-editor/esm/vs/language/html/html.worker', import.meta.url));
                }
                if (label === 'typescript' || label === 'javascript') {
                    return new Worker(new URL('monaco-editor/esm/vs/language/typescript/ts.worker', import.meta.url));
                }
                return new Worker(new URL('monaco-editor/esm/vs/editor/editor.worker', import.meta.url));
            }
        };
    }
}
